export const FeatureFlags = {
  SampleFlag: 'sample-feature',
  AMU1743: 'AMU-1743-Loft-Updates',
  AMU1483Dsi: 'AMU-1483-DSIV2',
  AIEnabled: 'AI-Enabled',
  AMU2104UseLegacyMessagingRules: 'Temp-AMU-2104-UseLegacyMessagingResolvingRules',
  DarkMode: 'dark-mode-enabled',
} as const;

export type FeatureFlagKey = keyof typeof FeatureFlags;
export type FeatureFlagValue = (typeof FeatureFlags)[FeatureFlagKey];
